import { createSlice } from "@reduxjs/toolkit";

/**
 * Estado inicial del store de depósitos
 */
const initialState = {
  depositos: [],
  depositoSeleccionado: null,
};

/**
 * Slice para los depósitos
 */
const depositosSlice = createSlice({
  name: "depositos",
  initialState,
  reducers: {
    setDepositos: (state, action) => {
      state.depositos = action.payload;
    },
    setDepositoSeleccionado: (state, action) => {
      state.depositoSeleccionado = action.payload;
    },
    resetDepositos: state => {
      state.depositos = [];
      state.depositoSeleccionado = null;
    },
  },
});

// ===== Exportar acciones =====
export const { setDepositos, setDepositoSeleccionado, resetDepositos } = depositosSlice.actions;

// ===== Selectores =====
export const selectDepositos = state => state.depositos.depositos;
export const selectDepositoSeleccionado = state => state.depositos.depositoSeleccionado;

// ===== Exportar reducer =====
export default depositosSlice.reducer;
